<!-- Loading -->
<div *ngIf="loading" class="flex flex-col items-center justify-center py-10 gap-2">
  <svg class="animate-spin h-7 w-7 text-blue-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
  </svg>
  <span class="text-xs text-gray-400">{{ 'Loading notifications…' | transloco }}</span>
</div>

<!-- Error -->
<div *ngIf="!loading && error" class="mx-3 my-4 flex items-center gap-2 rounded-lg bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-600">
  <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
  {{ 'Failed to load notifications' | transloco }}
</div>

<!-- Empty -->
<div *ngIf="!loading && !error && logs.length === 0" class="flex flex-col items-center justify-center py-10 gap-2 text-gray-400">
  <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
  </svg>
  <span class="text-sm">{{ 'No notifications' | transloco }}</span>
</div>

<!-- List -->
<ul *ngIf="!loading && !error && logs.length > 0" class="divide-y divide-gray-100">
  <li
    *ngFor="let log of logs"
    class="px-4 py-3 transition-colors"
    [ngClass]="getPriorityRowClass(log)"
    [class.cursor-pointer]="log.source"
    (click)="onItemClick(log)"
  >
    <div class="flex items-start justify-between gap-3">
      <!-- Left: message + timestamp -->
      <div class="min-w-0 flex-1">
        <!-- Unread dot + message -->
        <div class="flex items-start gap-2">
          <span *ngIf="!isRead(log.id)"
            class="mt-1.5 shrink-0 h-1.5 w-1.5 rounded-full bg-blue-500"></span>
          <span *ngIf="isRead(log.id)"
            class="mt-1.5 shrink-0 h-1.5 w-1.5"></span>
          <p
            class="text-sm break-words"
            [class.font-semibold]="!isRead(log.id)"
            [class.text-gray-900]="!isRead(log.id)"
            [class.text-gray-500]="isRead(log.id)"
          >{{ log.message }}</p>
        </div>
        <p *ngIf="log.createdAtUTC" class="text-xs text-gray-400 mt-1 pl-3">
          {{ log.createdAtUTC | appDate: dateFormat() : dateTimezone() }}
        </p>
      </div>
      <!-- Right: priority badge -->
      <div *ngIf="log.priority" class="shrink-0 flex flex-col items-center gap-0.5 pt-0.5">
        <span class="text-[9px] text-gray-400 uppercase tracking-widest mb-0.5">{{ 'Priority' | transloco }}</span>
        <span
          class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase shadow-sm"
          [ngClass]="getPriorityBadgeClass(log.priority)"
        >
          <!-- Colored dot -->
          <span class="h-1.5 w-1.5 rounded-full" [ngClass]="getPriorityDotClass(log.priority)"></span>
          {{ log.priority }}
        </span>
      </div>
    </div>
  </li>
</ul>
